import intlTelInput from 'intl-tel-input';

export default function initIntlPhone() {
    const countryData = intlTelInputGlobals.getCountryData();

    for (const element of document.querySelectorAll('.input-phone')) {
        const input = element.querySelector('.input');
        const inputOriginalValue = input.dataset.originalValue || '';
        const format = element.querySelector('[name="phone_format"]');

        const iti = intlTelInput(input, {
            initialCountry: 'lt',
            utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
            separateDialCode: true,
            autoPlaceholder: 'off',
            nationalMode: false,
        });

        input.addEventListener("countrychange", function() {
            format.value = iti.getSelectedCountryData().dialCode;
            input.value = '';
        });

        for(const data of countryData) {
            if (inputOriginalValue && inputOriginalValue.startsWith(data.dialCode)) {
                input.value = inputOriginalValue.replace(data.dialCode, '');
                iti.setCountry(data.iso2);
            }
        }
    }
}
